import React, { useEffect, useRef, useState } from 'react'
import './Login.css'
import topwave from "../../imgs/topwave.png";
import signup from "../../imgs/signup.png";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { UilEditAlt } from '@iconscout/react-unicons';

const Login = () => {
    const [input, setInput] = useState({ sr: "", password: "" });
    const [brinput, setBrinput] = useState({ brsr: "", brpassword: "" });
    const [showtable, setShowtable] = useState(false);
    const navigate = useNavigate();
    const notify = (msg) => toast(msg);
    const [DataSource, setDataSource] = useState([]);
    const [value, setValue] = useState('');
    const [tableFilter, setTableFilter] = useState([]);
    const refbrlogin = useRef(null);
    const refbrloginclose = useRef(null);

    const handlebranchlist = () => {
        setShowtable(!showtable);
    }

    const handlebrlogin = (event)=>{
        event.preventDefault();

        let rawData = {
            bno: brinput.brsr,
            bpass: brinput.brpassword,
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://softtesting.in/php/cust/brloginweb.php', formData, {
            'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {
            if (response.data === "Welcome to Account!!") {
                refbrloginclose.current.click();
                getbrinfo();
            }
            else {
                notify("चुकीचा पासवर्ड, पुन्हा प्रयत्न करा!");
            }
        }).catch(err => {
            console.log(err);
        });
    }

    useEffect(() => {
        axios.post('https://softtesting.in/php/cust/getbranchsweb.php', { "sr": localStorage.getItem("sr") }).then(function sample(response) {

            if (response.data) {
                setDataSource(response.data);

            }
        }).catch(err => {
            console.log(err);
        });
    }, []);

    const openbrlogin = () =>{
        refbrlogin.current.click();
    }

    const handleChange = (event) => {
        const name = event.target.name;
        const valuecurrent = event.target.value;

        setInput(value => ({ ...value, [name]: valuecurrent }))
    }

    const handlebrChange = (event) => {
        const name = event.target.name;
        const valuecurrent = event.target.value;

        setBrinput(value => ({ ...value, [name]: valuecurrent }))
    }

    const handlelogin = (event) => {
        event.preventDefault();

        let rawData = {
            sr: input.sr,
            password: input.password,
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://softtesting.in/php/cust/loginuserweb.php', formData, {
            'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {
            if (response.data === "Welcome to Account!!") {
                getuserinfo();
                // 

            }
            else {
                notify("चुकीचा पासवर्ड, पुन्हा प्रयत्न करा!");
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const getbrinfo = () => {

        let rawData = {
            brno: brinput.brsr,

        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://softtesting.in/php/cust/getbrweb.php', formData, {
            'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {
           
            if (response.data.length > 0) {
                {
                    response.data.map((user, index) => (
                        localStorage.setItem("brno", user.brno),
                        localStorage.setItem("message", user.message),
                        localStorage.setItem("inid", user.inid),
                        localStorage.setItem("atoken", user.atoken),
                        localStorage.setItem("bname", user.bname),
                        navigate("/brmain")
                    )
                    )
                }
              
            }
            else{
                navigate("/brmain");
            }

        }).catch(err => {
            console.log(err);
        });
    }

    const getuserinfo = () => {

        let rawData = {
            sr: input.sr,

        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://softtesting.in/php/cust/getmyprofileinfoweb.php', formData, {
            'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {
            if (response.data.length > 0) {
                {
                    response.data.map((user, index) => (
                        localStorage.setItem("name", user.name),
                        localStorage.setItem("age", user.age),
                        localStorage.setItem("jat", user.jat),
                        localStorage.setItem("vtype", user.vtype),
                        localStorage.setItem("quli", user.quli),
                        localStorage.setItem("fdate", user.fdate),
                        localStorage.setItem("dist", user.dist),
                        localStorage.setItem("counttype", user.counttype),
                        localStorage.setItem("brnomadh", user.brnomadh),
                        localStorage.setItem("madh", user.madh)
                    )
                    )
                }
                navigate("/Mainpage");
                notify("नमस्कार," + localStorage.getItem("name") + "आपले स्वागत आहे!");
                localStorage.setItem("sr", input.sr);
            }

        }).catch(err => {
            console.log(err);
        });
    }

    return (
        <>
            <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                hidden="{true}"
                ref={refbrlogin}
                data-bs-target="#exampleModalphoto"
            >
            </button>

            <div className="modal fade" id="exampleModalphoto" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document" >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Branch Login</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refbrloginclose} aria-label="Close">
                            </button>
                        </div>
                        <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "column" }} className="modal-body">
                            <input className="form-control search mx-3" maxLength="10" type="text" id="brsr" name="brsr" onChange={handlebrChange} placeholder='शाखा क्रमांक' />
                            <input className="form-control search mx-3 my-3" maxLength="10" type="password" id="brpassword" onChange={handlebrChange} name="brpassword" placeholder='शाखा पासवर्ड' />
                            <button type="button" onClick={handlebrlogin} className='btn btn-primary my-3 mx-2'>ओके</button>
                        </div>
                    </div>
                </div>
            </div>


            <div className='loginmain'>
                <div className="loginback">
                    <img className='topwave' src={topwave} alt="" />
                    <div className="topbox">
                        <span onClick={openbrlogin} className='heading'>आपले स्वागत आहे</span>
                        <span className='headingsub'>आपले अकाउंट लॉगिन करा</span>
                        <div className="whitebox">
                            <img className='signup' src={signup} alt="" />
                            <span onClick={handlebranchlist} className='regularbold'> आमच्या शाखा</span>
                        </div>
                    </div>
                    <div className={showtable ? "dnone" : "middlebox"}>
                        <input className="form-control search mx-3" maxLength="10" type="text" id="sr" name="sr" onChange={handleChange} placeholder='प्रोफाईल आयडी' />
                        <input className="form-control search mx-3 my-3" maxLength="10" type="password" id="password" onChange={handleChange} name="password" placeholder='पासवर्ड' />
                        <button type="button" onClick={handlelogin} className='btn btn-primary my-3 mx-2'>लॉगीन</button>
                    </div>
                    <div className={showtable ? "middleboxtable" : "dnone"}>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={handlebranchlist}
                            aria-label="Close"
                        ></button>
                        <div className="table-responsive">
                            <table id="table-to-xls" className="table table-striped">
                                <thead>
                                    <tr>
                                        <th className='regularbold' scope="col">सिरीयल</th>
                                        <th className='regularbold' scope="col">शाखा.क्र</th>
                                        <th className='regularbold' scope="col">शाखेचे नाव</th>
                                        <th className='regularbold' scope="col">गाव/शहर</th>
                                        <th className='regularbold' scope="col">संपर्क क्रमांक</th>


                                    </tr>
                                </thead>
                                <tbody>
                                    {value.length > 0 ? tableFilter.map((user, index) =>
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{user.sr}</td>
                                            <td>{user.bname}</td>
                                            <td>{user.address}</td>
                                            <td>{user.mobno}</td>

                                        </tr>
                                    )
                                        :
                                        DataSource.map((user, index) =>
                                            <tr key={index + 1}>
                                                <td className='regular'>{index}</td>
                                                <td className='regular'>{user.sr}</td>
                                                <td className='regular'>{user.bname}</td>
                                                <td className='regular'>{user.address}</td>
                                                <td className='regular'>{user.mobno}</td>

                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="line" />
                    <div className="bottomline">
                        <span className='regular'> आपण अजून खाते तयार केले नाही?</span>
                        <span className='regularbold aa'>आपले खाते तयार करा</span>
                    </div>
                </div>
                <ToastContainer />
            </div>
        </>
    )
}

export default Login
